import { FC } from 'react';
import GeoAudit from 'components/common/GeoAudit';

interface titleType {
  title1: string;
  title2: string;
  title3: string;
  fontsize1: number;
  fontsize2: number;
  movie: string;
  button: string;
  body: any;
  placeholder: string;
  intro: string;
  heading: string;
  auditHero?: boolean;
}
const Video: FC<titleType> = ({ intro, heading, title1, title2, title3, movie, body, placeholder, button, fontsize1, fontsize2, auditHero }) => {
  return (
    <section className="py-15 video-hero wrapper angled lower-start">
      <div className='flex justify-content-center'>
      <h2 style={{order: 1}} className="flex order-1">
        <span className="hero_text">
          <p className={`fs-${fontsize1}`} style={{ fontFamily: 'avenir !important' }}>{title1}</p>
          <span className={`fs-${fontsize2}`} style={{ fontFamily: 'avenir !important' }}>{title2}</span>
        </span>

        <video autoPlay loop playsInline muted poster={placeholder}>
          <source src={movie} type="video/mp4" />
        </video>
        {/* <span className={`fs-${fontsize2}`}>{title3}</span> */}
      </h2>
      {!auditHero && <h1 style={{order: 2, textAlign: 'center',
        paddingTop: '5vh', textTransform:"none"}} className="flex order-2 animate__animated animate__slideInUp animate__delay-1s">{heading}</h1>}</div>
      <div className="row">
        <div className="col-12 col-sm-12 col-lg-11 col-xl-10 mx-auto text-center mb-5">

          {!auditHero && <p className="animate__animated animate__slideInUp animate__delay-2s">
            {`SEOptimist  `}
            {intro}
          </p>}
          <div className="mt-4">
            <GeoAudit takeover showHeading={auditHero} />
          </div>
        </div>
      </div>
    </section >
  );
};

export default Video;
